import PageHero from '@/components/PageHero';
import TripleSection from '@/components/TripleSection';
import { useModal } from '@/lib/ModalContext';
import s from '@/components/home.module.css';

export default function Attorneys() {
  const { setOpen } = useModal();
  return (
    <>
      <PageHero
        eyebrow="For attorneys"
        title="Practice the law. We'll run the operations."
        sub="AVOWAL gives your practice its own white-label operations layer — your brand, your domain, an intake assistant you name and configure — and makes flat-fee, limited-scope representation profitable instead of punishing. Your clients stay yours, start to finish."
      />

      <TripleSection
        id="why-join"
        label="Why run your practice on it"
        title="You keep your firm. We remove the overhead."
        cards={[
          { num: '/ INDEPENDENCE', title: 'Your firm, your judgment', body: "We don't employ you, and we never stand between you and your clients. You stay independently licensed and personally accountable for the work you sign. Your clients see your firm throughout — nothing is signed or filed without you." },
          { num: '/ LEVERAGE', title: 'ELARIA does the paperwork', body: 'Intake, drafting, citation verification, deadline tracking, and exhibit assembly arrive done. You spend your hours on judgment and advocacy — the work only an attorney can do.' },
          { num: '/ ECONOMICS', title: 'Flat-fee that actually works', body: 'By automating the mechanical layer, limited-scope matters become viable at a flat fee. Predictable scope, predictable pay, no collections drama.' },
        ]}
      />

      <TripleSection
        id="how-engage"
        label="How engagement works"
        title="From your intake to your signature."
        cards={[
          { num: '/ 01', title: 'Your client starts', body: 'A client begins on your branded portal. ELARIA runs your configured intake, structures the matter, checks it against your own book for conflicts, and prepares a scoped flat-fee proposal anchored to your published rates.' },
          { num: '/ 02', title: 'You confirm', body: 'You review the prepared file, confirm or adjust scope, and sign the limited-scope engagement. The clock starts on the work, not the conversation.' },
          { num: '/ 03', title: 'You decide, ELARIA delivers', body: 'You make every judgment call and sign every filing. ELARIA prepares drafts, verifies citations, and keeps the audit trail. Every output is yours to review before it leaves.' },
        ]}
      />

      <section>
        <div className="container">
          <div className={s.cta}>
            <h2 className={s.ctaTitle}>See your firm on it.</h2>
            <p className={s.ctaSub}>
              We are onboarding a small founding cohort of independent, bar-admitted attorneys for the
              private beta. Tell us your jurisdiction and practice areas — we&rsquo;ll set up a live
              walkthrough of the platform running under your firm&rsquo;s brand.
            </p>
            <div className={s.ctaRow}>
              <button className={`${s.btn} ${s.btnPrimary}`} onClick={() => setOpen('waitlist')}>
                Request a walkthrough (attorneys only)
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
